import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import swal from 'sweetalert2';
import axios from 'axios';
import API from '../middleware/API';

const EditStaff = ({ editType, isShow, editInformation, jobTypeArray, onChangeFunc, saveFunc, toggleFunc, CarriedForwardHours,ResetCompensatoryHours}) => {
  //const [selectDate, setDate] = useState(editInformation.takeOfficeDate);

  const {
    id, 
    reset, 
    realName,
    birthDate, 
    idNumber, 
    jobTypeId, 
    cellPhone, 
    pay, 
    notes, 
    takeOfficeDate, 
    isPartTime, 
    takeOffHours, 
    totalHours,
    partTimeLeaveHours, 
    sDate, 
    eDate, 
    jobLevel, 
    carriedForwardHours, 
    lastRemainHours, 
    compensatoryHours, 
    monthSalary, 
    signingCompensatoryHours,
    // householdAddress,
    // mailingAddress,
    // emergencyContactName,
    // emergencyContactPhone,
    // baseSalary,
    // salaryBank,
    // bankAccountNumber,
    // pensionLevel,
    // laborInsuranceLevel,
    // healthInsuranceLevel,
    // healthDependentCount
  } = editInformation;
  // function handleSelectDateChange(momentDate) {
  //   console.log(momentDate.format('YYYY-MM-DD'))

  //   setDate(momentDate);
  // }

  
  function generateUserExcel() {
 
     swal({
       type: 'warning',
       title: '確定下載'+realName+'報表?',
       showCloseButton: true,
       heightAuto: false,
       showCancelButton: true,
       showConfirmButton: true,
       confirmButtonColor: '#3085d6',
       cancelButtonColor: '#A9ABA8',
       confirmButtonText: '確定',
       cancelButtonText: '取消',
     }).then((result) => {
       if (result.value) {
         axios({
           url:process.env.REACT_APP_NODE_ENV === 'development'?'https://www.liangshishu.link:46890/api/'+'/Chart/Generate/'+id:'https://www.liangshishu.link:46888/api/'+'/Chart/Generate/'+id,
           method: 'GET',
           headers:{
 'Authorization': 'bearer ' + localStorage.getItem('access_token'),
       'StoreId':1 },
       responseType: 'blob'}).then((response) => {
           const url = window.URL.createObjectURL(new Blob([response.data]));
           const link = document.createElement('a');
           link.href = url;
           link.setAttribute('download', realName+'出勤明細'+ new Date().toLocaleDateString() +'.xlsx'); //or any other extension
           document.body.appendChild(link);
           link.click();
           }).catch((error) => {
           swal({
             type: 'error',
             title: '下載失敗',
            text: error.response && error.response.status === 500 ? '伺服器錯誤，請稍後再試' : '下載報表時發生錯誤',
             heightAuto: false,
           });
         });
       }
     })
 
   }
//    function getSalaryRangeInfo(baseSalary) {
//   if (!baseSalary) return null;
//   const salary = Number(baseSalary);
//   // 找到小於等於baseSalary的最大amount
//   const range = ranges
//     .filter(r => r.amount <= salary)
//     .sort((a, b) => b.amount - a.amount)[0];

//     console.log('range', range);
//   return range || null;
// }

// const rangeInfo = getSalaryRangeInfo(editInformation.baseSalary);

  return (
    <div className="u-editblock fadeIn" style={{display: isShow === true ? 'flex' : 'none'}}>
      <div className="form-block" style={{maxWidth:'100%',overflowX:'auto',overflowY:'auto'}}>
        <div className="u-small-title">{editType === 'ADD' ? '新增' : '編輯'}員工</div>
        <form className="u-form u-form-userinfo"style={{minWidth:'600px'}} >
          <div className="row m-t-16">
            <div className="col-3 col-pad-6">
              <label className="u-form__label text-align-right">姓名：</label>
              <input value={realName} onChange={(e)=>{onChangeFunc('realName', e);}} className="u-form__input underline"/>
            </div>
            <div className="col-3 col-pad-6">
              <label className="u-form__label text-align-right">生日：</label>
              <input style={{fontSize:'12px'}} value={birthDate}  onChange={(e)=>{onChangeFunc('birthDate', e);}} className="u-form__input underline"/>
              </div>


            <div className="col-6 col-pad-6">
              <label className="u-form__label text-align-right">身分證：</label>
              <input value={idNumber} onChange={(e)=>{onChangeFunc('idNumber', e);}} className="u-form__input underline"/>
            </div>

            <div className="col-12 col-pad-6">
                <div className="u-notice">※生日格式，例:90年5月1日，輸入:0900501。</div>
                </div>
          </div>
          <div className="row">
            <div className="col-6 col-pad-6">
              <label className="u-form__label text-align-right">職位：</label>
              <select value={Number(jobTypeId)} className="u-form__select" 
                onChange={(e)=>{onChangeFunc('jobTypeId', e);}}
              >
                <option value="0" disabled>請選擇職位</option>
                {
                  jobTypeArray.map(jobType => (
                    <option key={jobType.id} value={jobType.id}>{ jobType.name }</option>
                  ))
                }
              </select>
            </div>
            <div className="col-6 col-pad-6">
              <label className="u-form__label text-align-right">手機：</label>
              <input value={cellPhone} onChange={(e)=>{onChangeFunc('cellPhone', e);}} className="u-form__input underline"/>
            </div>
          </div>
          <div className="row">
            <div className="col-6 col-pad-6">
              <label className="u-form__label text-align-right">正/兼職：</label>
              <select value={isPartTime} className="u-form__select" 
                onChange={(e)=>{onChangeFunc('isPartTime', e);}}
              >
                <option value="0" disabled>請選擇職位</option>
                <option key='1' value={true}>兼職</option>
                <option key='2' value={false}>正職</option>

              </select>
            </div>
            {
              isPartTime ||  editType === 'ADD' ?
              ''
              :
              <div className="col-6 col-pad-6">
              <label className="u-form__label text-align-right">特休已休時數：</label>
              {
                takeOffHours === -1 ?
                <label className="u-form__label text-align-right">未滿半年無特休</label>
                :
                <label className="u-form__label text-align-right">{takeOffHours}</label>
              }
            </div>
            }

          </div>
          <div className="row">
          <div className="col-6 col-pad-6">
              <div style={{ flex: '0 0 90px' }}>
                <span className="u-form__label text-align-right">到職日期：</span>
              </div>
              <DatePicker
                id="add_date_picker_selectDate"
                locale="zh-tw"
                dateFormat="YYYY-MM-DD"
                timeCaption="Time"
                selected={takeOfficeDate}
                onChange={(e)=>{onChangeFunc('takeOfficeDate', e);}}
                className="u-form__input"
                disabledKeyboardNavigation
              />
            </div>
            <div className="col-6 col-pad-6">
            {
                takeOffHours === -1 ?
                <label className="u-form__label text-align-right"></label>
                :
                editType === 'ADD' ? <label className="u-form__label text-align-right"></label>:
                isPartTime?
                //<label className="u-form__label text-align-right">最大可休時數：{partTimeLeaveHours + carriedForwardHours}</label>
                '':
                <label className="u-form__label text-align-right">最大可休時數：{totalHours + carriedForwardHours}</label>
              }
            </div>
          </div>
          { //本期大於0表示已轉換，本期小於0且上期小於0表示新人
            isPartTime || editType === 'ADD' ? '':
            carriedForwardHours > 0 || (carriedForwardHours <= 0 && lastRemainHours<= 0)?
              <div className="row">
                <div className="col-6 col-pad-6">
                   <div style={{ flex: '0 0 90px'}}>
                   <span className="u-form__label text-align-right u-table-media">上期剩餘特休時數：0</span>
                   <span className="u-form__label text-align-right u-table-media-phone" style={{fontSize:'14px'}}>上期剩餘特休時數：0</span>
                   </div>
                 </div>
                 <div className="col-6 col-pad-6">
                   <div style={{ flex: '0 0 90px'}}>
                   <span className="u-form__label text-align-right u-table-media">目前補休時數：{compensatoryHours - signingCompensatoryHours}
                    <button type="button" style={{marginLeft:'8px'}} onClick={()=>{ResetCompensatoryHours(id, realName)}} >重置補休</button>
                   </span>
                   <span className="u-form__label text-align-right u-table-media-phone" style={{fontSize:'14px'}}>目前補休時數：{compensatoryHours - signingCompensatoryHours}
                    <button type="button" style={{marginLeft:'8px'}} onClick={()=>{ResetCompensatoryHours(id, realName)}} >重置補休</button>
                   </span>
                   </div>
                </div>
               </div>
            :
              <div className="row">
                <div className="col-6 col-pad-6">
                   <div style={{ flex: '0 0 90px'}}>
                   <span className="u-form__label text-align-right u-table-media">上期剩餘特休時數：{lastRemainHours}<button type="button" style={{marginLeft:'8px'}} onClick={()=>{CarriedForwardHours(id)}} >轉換時數</button></span>
                   <span className="u-form__label text-align-right u-table-media-phone" style={{fontSize:'14px'}}>上期剩餘特休時數：{lastRemainHours}<button type="button" style={{marginLeft:'8px'}} onClick={()=>{CarriedForwardHours(id)}} >轉換時數</button></span>
                   </div>
                </div>
                <div className="col-6 col-pad-6">
                   <div style={{ flex: '0 0 90px'}}>
                   <span className="u-form__label text-align-right u-table-media">目前補休時數：{compensatoryHours - signingCompensatoryHours}            
                    <button type="button" style={{marginLeft:'8px'}} onClick={()=>{ResetCompensatoryHours(id, realName)}} >重置補休</button>
                   </span>
                   <span className="u-form__label text-align-right u-table-media-phone" style={{fontSize:'14px'}}>目前補休時數：{compensatoryHours - signingCompensatoryHours}
                    <button type="button" style={{marginLeft:'8px'}} onClick={()=>{ResetCompensatoryHours(id, realName)}} >重置補休</button>

                   </span>
                   </div>
                </div>

                <div className="col-6 col-pad-6">
                <div className="u-notice">※若特休需轉換現金請通知南辦。</div>
                </div>
                <div className="col-6 col-pad-6">
                <div className="u-notice">※目前補休時數會扣掉簽核中的補休單</div>
                </div>
              </div>
          }              

          {
                takeOffHours === -1 ||isPartTime ?
                ''
                :
                <div className="row">
                <div className="col-12">
                   <div style={{ flex: '0 0 90px'}}>
                   <span className="u-form__label text-align-right u-table-media">特休日期區間：{sDate} ~ {eDate}</span>
                   <span className="u-form__label text-align-right u-table-media-phone" style={{fontSize:'14px'}}>特休日期區間：{sDate} ~ {eDate}</span>
                   </div>
                 </div>
               </div>              }

          <div className="row">
            <div className="col-6 col-pad-6">
              <label className="u-form__label text-align-right">薪資：</label>
              <input type='number' value={pay} onChange={(e)=>{onChangeFunc('pay', e);}} className="u-form__input underline"/>
              <label className="u-form__label text-align-left">/小時</label>
            </div>
            <div className="col-6 col-pad-6">
            <label className="u-form__label text-align-right">職等：</label>
              <input value={jobLevel || ''} onChange={(e)=>{onChangeFunc('jobLevel', e);}} className="u-form__input underline"/>
            </div>
          </div>
          {
            monthSalary?
            <div className="row">
            <div className="col-6 col-pad-6">
              <label className="u-form__label text-align-right">月薪：{monthSalary}</label>
            </div>
          </div>:''
          }
          {/* 地址資訊 */}
<div className="row">
  <div className="col-6 col-pad-6">
    <label className="u-form__label text-align-right">戶籍地址：</label>
    <input value={editInformation.householdAddress || ''} onChange={e => onChangeFunc('householdAddress', e)} className="u-form__input underline"/>
  </div>
  <div className="col-6 col-pad-6">
    <label className="u-form__label text-align-right">通訊地址：</label>
    <input value={editInformation.mailingAddress || ''} onChange={e => onChangeFunc('mailingAddress', e)} className="u-form__input underline"/>
  </div>
</div>

{/* 緊急聯絡人 */}
<div className="row">
  <div className="col-6 col-pad-6">
    <label className="u-form__label text-align-right">緊急聯絡人：</label>
    <input value={editInformation.emergencyContactName || ''} onChange={e => onChangeFunc('emergencyContactName', e)} className="u-form__input underline"/>
  </div>
  <div className="col-6 col-pad-6">
    <label className="u-form__label text-align-right">緊急聯絡人電話：</label>
    <input value={editInformation.emergencyContactPhone || ''} onChange={e => onChangeFunc('emergencyContactPhone', e)} className="u-form__input underline"/>
  </div>
</div>

{/* 薪資與銀行資訊 */}
<div className="row">
  <div className="col-6 col-pad-6">
    <label className="u-form__label text-align-right">本薪：</label>
    <input type="number" value={editInformation.baseSalary || ''} 
    onChange={e => onChangeFunc('baseSalary', e)} 
      //     onChange={e => {
      //   onChangeFunc('baseSalary', e);
      //   // 自動填入對應級距
      //   const info = getSalaryRangeInfo(e.target.value);
      //   if (info) {
      //     onChangeFunc('healthInsuranceLevel', { target: { value: info.health_insurance_employee } });
      //     onChangeFunc('laborInsuranceLevel', { target: { value: info.labor_insurance_employee } });
      //     onChangeFunc('pensionLevel', { target: { value: info.pension } });
      //   }
      // }}
    className="u-form__input underline"/>
  </div>
  <div className="col-6 col-pad-6">
    <label className="u-form__label text-align-right">薪轉銀行：</label>
    <input value={editInformation.salaryBank || ''} onChange={e => onChangeFunc('salaryBank', e)} className="u-form__input underline"/>
  </div>
</div>
<div className="row">
  <div className="col-6 col-pad-6">
    <label className="u-form__label text-align-right">銀行帳號：</label>
    <input value={editInformation.bankAccountNumber || ''} onChange={e => onChangeFunc('bankAccountNumber', e)} className="u-form__input underline"/>
  </div>
</div>
{/* 保險與勞退資訊 */}
<div className="row">

  <div className="col-6 col-pad-6">

    <label className="u-form__label text-align-right">勞退級距：</label>
    <input type="number" value={editInformation.pensionLevel || ''} onChange={e => onChangeFunc('pensionLevel', e)} className="u-form__input underline"/>
  </div>
  <div className="col-6 col-pad-6">
    <label className="u-form__label text-align-right">勞保級距：</label>
    <input type="number" value={editInformation.laborInsuranceLevel || ''} onChange={e => onChangeFunc('laborInsuranceLevel', e)} className="u-form__input underline"/>
  </div>
</div>
<div className="row">
  <div className="col-6 col-pad-6">
    <label className="u-form__label text-align-right">健保級距：</label>
    <input type="number" value={editInformation.healthInsuranceLevel || ''} onChange={e => onChangeFunc('healthInsuranceLevel', e)} className="u-form__input underline"/>
  </div>
  <div className="col-6 col-pad-6">
    <label className="u-form__label text-align-right">健保眷屬數：</label>
    <input type="number" value={editInformation.healthDependentCount || ''} onChange={e => onChangeFunc('healthDependentCount', e)} className="u-form__input underline"/>
  </div>
</div>
          <div className="row m-t-16">
            <div className="col-12 col-pad-12">
          <label className="u-form__label text-align-right">備註(上限500字)：<br/>目前字數：{notes?notes.length:0}</label>
              <textarea style={{resize:'none',padding:'3px',width:'100%', marginTop:'1px'}} rows='5' value={notes ||''} onChange={(e)=>{
                if(e.target.value.length > 500)
                  return;
                onChangeFunc('notes', e);
                }} />
            </div>
          </div>
          <div className="u-notice">※正／兼職轉換會影響特休，修正後請告知資訊人員。</div>
          
          <div className="u-notice">※正職請除以240小時，換算成時薪再乘以1.2。</div>
          <div className="u-notice">※輸入請小心輸入，手機為員工登入帳號、身分證為密碼。</div>
          <div className="u-btn-group right">
            
          <button className="btn btn-md edit m-r-16" onClick={(e) => {  e.preventDefault(); generateUserExcel(); } }>下載個人報表</button>

            <button className="btn btn-md save" onClick={(e) => {
              e.preventDefault();
              saveFunc();
            }}>儲存</button>
            <button className="btn btn-md cancel m-l-16" onClick={
              (e) => {
                e.preventDefault();
                toggleFunc();
              }
            }>取消</button>
          </div>
        </form>
      </div>
    </div>
  )

}

export default EditStaff;